import React, {FC} from 'react';

import {useRefreshSession} from '@app/helpers/useRefreshSession';
import {useSessionAndTradeNameHandler} from '@app/helpers/useSessionAndTradeNameHandler';

const AppBootstrap: FC = () => {
  useRefreshSession();
  useSessionAndTradeNameHandler();

  return <></>;
};

export {AppBootstrap};
